// src/App.js
import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "./AuthContext";
import { ThemeProvider } from "./ThemeContext";
import { ToastProvider } from "./components/Toast";
import { LoadingProvider } from "./components/LoadingBar";
import InstallPrompt from "./components/InstallPrompt";
import LandingPage from "./pages/LandingPage";
import AuthPage from "./pages/AuthPage";
import Dashboard from "./pages/Dashboard";
import AdminDashboard from "./pages/AdminDashboard";
import ProfilePage from "./pages/ProfilePage";
import CustomerDirectory from "./pages/CustomerDirectory";
import { ADMIN_UID } from "./config";

function ProtectedRoute({ children, adminOnly = false }) {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", background: "var(--bg-primary)" }}>
        <div style={{ textAlign: "center" }}>
          <div className="spinner" style={{ width: 48, height: 48, margin: "0 auto 16px", borderWidth: 3 }} />
          <p style={{ color: "var(--text-muted)" }}>Loading...</p>
        </div>
      </div>
    );
  }

  if (!user) return <Navigate to="/login" />;
  if (adminOnly && user.uid !== ADMIN_UID) return <Navigate to="/dashboard" />;
  return children;
}

function AppRoutes() {
  const { user } = useAuth();
  const isAdmin = user?.uid === ADMIN_UID;

  return (
    <Routes>
      <Route path="/" element={user ? <Navigate to={isAdmin ? "/admin" : "/dashboard"} /> : <LandingPage />} />
      <Route path="/login" element={user ? <Navigate to={isAdmin ? "/admin" : "/dashboard"} /> : <AuthPage />} />
      <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
      <Route path="/profile" element={<ProtectedRoute><ProfilePage /></ProtectedRoute>} />
      <Route path="/admin" element={<ProtectedRoute adminOnly><AdminDashboard /></ProtectedRoute>} />
      <Route path="/admin/customers" element={<ProtectedRoute adminOnly><CustomerDirectory /></ProtectedRoute>} />
      <Route path="*" element={<Navigate to={user ? (isAdmin ? "/admin" : "/dashboard") : "/"} />} />
    </Routes>
  );
}

export default function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <ToastProvider>
          <LoadingProvider>
            <AppRoutes />
            <InstallPrompt />
          </LoadingProvider>
        </ToastProvider>
      </AuthProvider>
    </ThemeProvider>
  );
}
